import TaxTraitsView from './TaxTraitsView';

export default TaxTraitsView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/taxTraits/index.js